import { Popover, Radio } from "@mui/material";
import { Box } from "@mui/system";
import DropdownBox from "../Common/DropdownBox";
import { useState } from "react";
import "../../styles/actionItems.css";

interface StatusSelectorProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    error?: boolean;
    options: Array<{ label: string; value: string; color: string; }>;
    id: string;
    activeDropdownId: string | null;
    setActiveDropdownId: (id: string | null) => void;
  }
  
  const StatusSelector: React.FC<StatusSelectorProps> = ({
    value,
    onChange,
    disabled,
    error,
    options,
    id,
    activeDropdownId,
    setActiveDropdownId,
  }) => {
    const isOpen = activeDropdownId === id;
    const [localAnchorEl, setLocalAnchorEl] = useState<HTMLElement | null>(null);
    const displayedStatus = options.find((s) => s.value === value);
    const selectedOpt = options.find((s) => s.value === value);

    const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
      if (disabled) return;
      setLocalAnchorEl(e.currentTarget);
      setActiveDropdownId(id);
    };

    const handleClose = () => {
      setActiveDropdownId(null);
      setLocalAnchorEl(null);
    };
  
    return (
      <>
        <DropdownBox
          onClick={handleOpen}
          error={error}
          disabled={disabled}
          className="status-box"
        >
          <Box className="status-display" sx={{ paddingTop: "10px" }}>
            <Radio checked={!!value} className= "status-radio"
      sx={{
        color: selectedOpt?.color,
        "&.Mui-checked": {
          color: selectedOpt?.color,
        },
      }} disableRipple />
            <span className="priority-label">{displayedStatus?.label || "Select"}</span>
          </Box>
        </DropdownBox>
  
        <Popover
          open={isOpen && Boolean(localAnchorEl)}
          anchorEl={localAnchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Box className="priority-popover">
            {options.map((opt, idx) => (
              <Box
                key={idx}
                className="priority-popover__option"
                onClick={() => {
                  onChange(opt.value);
                  setLocalAnchorEl(null);
                }}
              >
                <Radio
                checked={value === opt.value}
                className="status-radio"
                style={{ "--dynamic-color": opt.color } as any}
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "var(--dynamic-color) !important",
                  },
                }}
              />
                <span>{opt.label}</span>
              </Box>
            ))}
          </Box>
        </Popover>
      </>
    );
  };

export default StatusSelector